import React from "react";

export const LandingPageContext = React.createContext();
export const LayoutContext = React.createContext();
export const MusicPlayerContext = React.createContext();
export const TestingContext = React.createContext();
export const ThemeContext = React.createContext();
export const SongContext = React.createContext();
export const InfoContext = React.createContext();
export const ApplicationContext = React.createContext();
export const WebAudioContext = React.createContext();
